const graphIGUrl = 'https://graph.instagram.com';

const personalUserFields = 'account_type,id,media_count,username';

const personalMediaFields = 'caption,id,is_shared_to_feed,media_type,media_url,permalink,thumbnail_url,timestamp,username,children{id,media_type,media_url,permalink,thumbnail_url,timestamp}';

export const getUserURL = (accessToken) => `${graphIGUrl}/me?fields=${personalUserFields}&access_token=${accessToken}`;

export const getMediaURL = (accessToken, limit = 200) => `${graphIGUrl}/me/media?fields=${personalMediaFields}&limit=${limit}&access_token=${accessToken}`;